// ─── Impression HTML (Core) ───────────────────────────────────────
// Sur le WEB : ouvre une fenêtre et lance l'impression du navigateur (l'usager
// choisit « Enregistrer en PDF »). Sur MOBILE, les modules qui en ont besoin
// passent par expo-print (chargé paresseusement chez eux, pas ici : le Core ne
// doit tirer aucun module natif).
import { Platform } from 'react-native';

export function imprimerHTML(html) {
  if (Platform.OS !== 'web') return false;
  const win = window.open('', '_blank');
  if (!win) return false;
  win.document.open();
  win.document.write(html);
  win.document.close();
  // Laisse le rendu se faire avant d'ouvrir la boîte d'impression.
  setTimeout(() => { try { win.focus(); win.print(); } catch {} }, 400);
  return true;
}
